export const booksInitialState={
    categories:[],
    booksData:[],
    wishlist:[],
    cart:[],
    orders:[]
}